import { render } from "./CosmoBuildAppSettings.vue?vue&type=template&id=5903cda8&scoped=true"
import script from "./CosmoBuildAppSettings.vue?vue&type=script&lang=js"
export * from "./CosmoBuildAppSettings.vue?vue&type=script&lang=js"

import "./CosmoBuildAppSettings.vue?vue&type=style&index=0&id=5903cda8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5903cda8"]])

export default __exports__